var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.374,1.084a.75.75,0,0,0-1.248,0L2.25,7.5H4.5L1.6,11.628A.75.75,0,0,0,2.25,12.75h9a.75.75,0,0,0,.651-1.122L9,7.5h2.25Z",
    fill: "none",
    stroke: "#f9f9f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12.75L6.75 17.332",
    fill: "none",
    stroke: "#f9f9f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.262,1.023a.614.614,0,0,0-1.021,0L15.069,6H16.91L14.332,9.582a.613.613,0,0,0,.533.918h7.77a.613.613,0,0,0,.533-.918L20.592,6h1.841Z",
    fill: "none",
    stroke: "#f9f9f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.751 10.5L18.751 14.535",
    fill: "none",
    stroke: "#f9f9f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.805,18a13.517,13.517,0,0,1,15.673,5.254",
    fill: "none",
    stroke: "#f9f9f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.969,18.518A15.7,15.7,0,0,1,21.75,14.25q.759,0,1.5.07",
    fill: "none",
    stroke: "#f9f9f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeIcon);
export default __webpack_public_path__ + "static/media/tree-icon.39fd1426344382b0d96ab1893a7cb195.svg";
export { ForwardRef as ReactComponent };